module.exports = __webpack_public_path__ + "static/media/RHOutSwing.dc10eda0.svg";